// adjustObjectHeight()はなぜかいろんなinterfaceに実装されている...独自で実装.
// TODO: 他の実装箇所も本interfaceを使うよう置き換え検討する事.
export interface IObjectHeightAdjustable {
  adjustObjectHeight(): void;
}

export function instanceOfIObjectHeightAdjustable(instance: any): instance is IObjectHeightAdjustable {
  return instance
      && (instance.adjustObjectHeight !== undefined);
}
